import React, { useEffect, useState } from "react";
import { api } from "@/lib/auth";
import { useLang } from "@/lib/lang";
import { toast } from "sonner";
import { Gift, Share2 } from "lucide-react";

export default function ReferralBanner() {
    const { t } = useLang();
    const [link, setLink] = useState("");
    const [referredCount, setReferredCount] = useState(0);

    useEffect(() => {
        api.get("/referrals/link")
            .then((r) => {
                setLink(r.data.url);
                setReferredCount(r.data.referred_count || 0);
            })
            .catch(() => {});
    }, []);

    const copy = async () => {
        try {
            await navigator.clipboard.writeText(link);
            toast.success(t("referral.link_copied"));
        } catch (e) {
            toast.error(t("common.error"));
        }
    };

    const share = async () => {
        if (!link) return;
        if (navigator.share) {
            try {
                await navigator.share({ title: "Vivoz", text: t("referral.headline"), url: link });
                return;
            } catch (e) {
                return; // user cancelled the native share sheet
            }
        }
        copy();
    };

    return (
        <div className="bg-brand text-white p-6 lg:p-8 mb-16 flex flex-wrap items-center justify-between gap-6" data-testid="referral-banner">
            <div className="flex items-center gap-4 min-w-0">
                <Gift size={32} className="flex-shrink-0" />
                <div className="min-w-0">
                    <div className="font-display text-xl md:text-2xl tracking-tight" data-testid="referral-banner-headline">
                        {t("referral.headline")}
                    </div>
                    <div className="text-sm text-white/80 mt-1">{t("referral.sub")}</div>
                    {referredCount > 0 && (
                        <div className="text-sm text-white/80 mt-1" data-testid="referral-banner-count">
                            {t("referral.count_prefix")} {referredCount}
                        </div>
                    )}
                </div>
            </div>
            <button
                onClick={share}
                disabled={!link}
                className="bg-white text-brand font-semibold px-5 py-3 rounded-sm flex items-center gap-2 hover:bg-white/90 transition-colors flex-shrink-0 disabled:opacity-60"
                data-testid="referral-banner-btn"
            >
                <Share2 size={16} /> {t("referral.cta")}
            </button>
        </div>
    );
}
